module.exports = __webpack_public_path__ + "static/media/QD.7cfa0d3d.svg";